














import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class DeleteRoleDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop() private role!: {_id: string, name: string, requireCenter: boolean}
  @Prop() private callback!: () => Promise<void>

  private loading = false

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get deleteUserDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ลบ',
          action: this.deleteRoleAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  private async deleteRoleAction() {
    this.loading = true
    try {
      await HttpRequestServiceWithToken.delete(
        `${process.env.VUE_APP_API_URL}/v1/role/${this.role._id}`,
        {},
        async () => {
          this.updateSnackbar({txt: 'ลบหน้าที่สำเร็จ.', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        },
      )
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
  private created() {
    // console.log(this.role)
  }
}
